
let defaultState = {
    time : '',
    date : '',
    participants : [],
    updated : false
};

const urlquery = (state = defaultState, action) => {
    switch (action.type) {
        case 'NEW_QUERY':
            return {
                time : action.data.time && action.data.time !== '' ? action.data.time : '',
                date : action.data.date && action.data.date !== '' ? action.data.date : '',
                participants : action.data.participants && action.data.participants.length>0 ? action.data.participants : [],
                updated : true
            };
        default:
            return state
    }
};

export default urlquery


// WEBPACK FOOTER //
// ./src/services/reducers/urlquery.js